var map = {
	"./clear/100_dice/100_dice[10].png": "eaa8",
	"./clear/100_dice/100_dice[1].png": "fe38",
	"./clear/100_dice/100_dice[2].png": "d551",
	"./clear/100_dice/100_dice[3].png": "855e",
	"./clear/100_dice/100_dice[4].png": "e072",
	"./clear/100_dice/100_dice[5].png": "fb87",
	"./clear/100_dice/100_dice[6].png": "3713",
	"./clear/100_dice/100_dice[7].png": "83d3",
	"./clear/100_dice/100_dice[8].png": "c240",
	"./clear/100_dice/100_dice[9].png": "ad79",
	"./clear/10_dice/10_dice[10].png": "f82c",
	"./clear/10_dice/10_dice[1].png": "8306",
	"./clear/10_dice/10_dice[2].png": "07ca",
	"./clear/10_dice/10_dice[3].png": "995b",
	"./clear/10_dice/10_dice[4].png": "ac99",
	"./clear/10_dice/10_dice[5].png": "7262",
	"./clear/10_dice/10_dice[6].png": "2876",
	"./clear/10_dice/10_dice[7].png": "9182",
	"./clear/10_dice/10_dice[8].png": "2fe8",
	"./clear/10_dice/10_dice[9].png": "c416",
	"./clear/12_dice/12_dice[10].png": "f986",
	"./clear/12_dice/12_dice[11].png": "a834",
	"./clear/12_dice/12_dice[12].png": "b500",
	"./clear/12_dice/12_dice[1].png": "b08f",
	"./clear/12_dice/12_dice[2].png": "d348",
	"./clear/12_dice/12_dice[3].png": "e2b6",
	"./clear/12_dice/12_dice[4].png": "c563",
	"./clear/12_dice/12_dice[5].png": "5b57",
	"./clear/12_dice/12_dice[6].png": "89fc",
	"./clear/12_dice/12_dice[7].png": "7c22",
	"./clear/12_dice/12_dice[8].png": "36f1",
	"./clear/12_dice/12_dice[9].png": "6e8b",
	"./clear/20_dice/20_dice[10].png": "8927",
	"./clear/20_dice/20_dice[11].png": "7917",
	"./clear/20_dice/20_dice[12].png": "545b",
	"./clear/20_dice/20_dice[13].png": "05bb",
	"./clear/20_dice/20_dice[14].png": "e2f7",
	"./clear/20_dice/20_dice[15].png": "9db4",
	"./clear/20_dice/20_dice[16].png": "babc",
	"./clear/20_dice/20_dice[17].png": "4e9e",
	"./clear/20_dice/20_dice[18].png": "974c",
	"./clear/20_dice/20_dice[19].png": "b336",
	"./clear/20_dice/20_dice[1].png": "b633",
	"./clear/20_dice/20_dice[20].png": "b998",
	"./clear/20_dice/20_dice[2].png": "94bc",
	"./clear/20_dice/20_dice[3].png": "3f4a",
	"./clear/20_dice/20_dice[4].png": "60aa",
	"./clear/20_dice/20_dice[5].png": "99cf",
	"./clear/20_dice/20_dice[6].png": "df11",
	"./clear/20_dice/20_dice[7].png": "e79f",
	"./clear/20_dice/20_dice[8].png": "65bf",
	"./clear/20_dice/20_dice[9].png": "2104",
	"./clear/4_dice/4_dice[1].png": "8b62",
	"./clear/4_dice/4_dice[2].png": "f378",
	"./clear/4_dice/4_dice[3].png": "7cc5",
	"./clear/4_dice/4_dice[4].png": "9040",
	"./clear/6_dice/6_dice[1].png": "56d2",
	"./clear/6_dice/6_dice[2].png": "6a998",
	"./clear/6_dice/6_dice[3].png": "9cdd",
	"./clear/6_dice/6_dice[4].png": "bdfb",
	"./clear/6_dice/6_dice[5].png": "e123",
	"./clear/6_dice/6_dice[6].png": "fc58",
	"./clear/6_dice_black/6_dice[0].png": "2a1e",
	"./clear/6_dice_black/6_dice[1].png": "2beb",
	"./clear/6_dice_black/6_dice[2].png": "48ed",
	"./clear/6_dice_black/6_dice[3].png": "99db",
	"./clear/6_dice_black/6_dice[4].png": "a1ef",
	"./clear/6_dice_black/6_dice[5].png": "c37f",
	"./clear/6_dice_black/6_dice[6].png": "480b",
	"./clear/8_dice/8_dice[1].png": "59fc",
	"./clear/8_dice/8_dice[2].png": "b560",
	"./clear/8_dice/8_dice[3].png": "77ec",
	"./clear/8_dice/8_dice[4].png": "ed25",
	"./clear/8_dice/8_dice[5].png": "4124",
	"./clear/8_dice/8_dice[6].png": "42eb",
	"./clear/8_dice/8_dice[7].png": "7f06",
	"./clear/8_dice/8_dice[8].png": "4a8b",
	"./default/100_dice/100_dice[10].png": "ff05",
	"./default/100_dice/100_dice[1].png": "03f1",
	"./default/100_dice/100_dice[2].png": "ab05",
	"./default/100_dice/100_dice[3].png": "3856",
	"./default/100_dice/100_dice[4].png": "610c",
	"./default/100_dice/100_dice[5].png": "1e4c",
	"./default/100_dice/100_dice[6].png": "d8cd",
	"./default/100_dice/100_dice[7].png": "ea77",
	"./default/100_dice/100_dice[8].png": "0dc9",
	"./default/100_dice/100_dice[9].png": "5487",
	"./default/10_dice/10_dice[10].png": "9806",
	"./default/10_dice/10_dice[1].png": "a49d",
	"./default/10_dice/10_dice[2].png": "6a8d",
	"./default/10_dice/10_dice[3].png": "460c",
	"./default/10_dice/10_dice[4].png": "846d",
	"./default/10_dice/10_dice[5].png": "37cd",
	"./default/10_dice/10_dice[6].png": "4bf1",
	"./default/10_dice/10_dice[7].png": "9362",
	"./default/10_dice/10_dice[8].png": "5bcb",
	"./default/10_dice/10_dice[9].png": "0f8e",
	"./default/12_dice/12_dice[10].png": "f065",
	"./default/12_dice/12_dice[11].png": "ca1f",
	"./default/12_dice/12_dice[12].png": "19a0",
	"./default/12_dice/12_dice[1].png": "c89f",
	"./default/12_dice/12_dice[2].png": "1d1d",
	"./default/12_dice/12_dice[3].png": "3bdc",
	"./default/12_dice/12_dice[4].png": "648a",
	"./default/12_dice/12_dice[5].png": "65af",
	"./default/12_dice/12_dice[6].png": "de88",
	"./default/12_dice/12_dice[7].png": "6d15",
	"./default/12_dice/12_dice[8].png": "33c5",
	"./default/12_dice/12_dice[9].png": "6118",
	"./default/20_dice/20_dice[10].png": "310e",
	"./default/20_dice/20_dice[11].png": "068b",
	"./default/20_dice/20_dice[12].png": "78fd",
	"./default/20_dice/20_dice[13].png": "6fb2",
	"./default/20_dice/20_dice[14].png": "1ac9",
	"./default/20_dice/20_dice[15].png": "9eca",
	"./default/20_dice/20_dice[16].png": "1e76",
	"./default/20_dice/20_dice[17].png": "af3d",
	"./default/20_dice/20_dice[18].png": "540c",
	"./default/20_dice/20_dice[19].png": "00bb",
	"./default/20_dice/20_dice[1].png": "fe70",
	"./default/20_dice/20_dice[20].png": "bc17",
	"./default/20_dice/20_dice[2].png": "01db",
	"./default/20_dice/20_dice[3].png": "e683",
	"./default/20_dice/20_dice[4].png": "9ba9",
	"./default/20_dice/20_dice[5].png": "0666",
	"./default/20_dice/20_dice[6].png": "47e6",
	"./default/20_dice/20_dice[7].png": "a111",
	"./default/20_dice/20_dice[8].png": "3d6d",
	"./default/20_dice/20_dice[9].png": "1298",
	"./default/4_dice/4_dice[1].png": "cff7",
	"./default/4_dice/4_dice[2].png": "cef3",
	"./default/4_dice/4_dice[3].png": "942f",
	"./default/4_dice/4_dice[4].png": "304f",
	"./default/6_dice/6_dice[0].png": "6b3f",
	"./default/6_dice/6_dice[1].png": "90a2",
	"./default/6_dice/6_dice[2].png": "2aed",
	"./default/6_dice/6_dice[3].png": "86ce",
	"./default/6_dice/6_dice[4].png": "d378",
	"./default/6_dice/6_dice[5].png": "1476",
	"./default/6_dice/6_dice[6].png": "b0a7",
	"./default/6_dice_black/6_dice[0].png": "2869",
	"./default/6_dice_black/6_dice[1].png": "c7ca",
	"./default/6_dice_black/6_dice[2].png": "1d97",
	"./default/6_dice_black/6_dice[3].png": "8a01e",
	"./default/6_dice_black/6_dice[4].png": "27ed",
	"./default/6_dice_black/6_dice[5].png": "a853",
	"./default/6_dice_black/6_dice[6].png": "3aff",
	"./default/8_dice/8_dice[1].png": "1fde",
	"./default/8_dice/8_dice[2].png": "7227",
	"./default/8_dice/8_dice[3].png": "8b48",
	"./default/8_dice/8_dice[4].png": "b624",
	"./default/8_dice/8_dice[5].png": "306a",
	"./default/8_dice/8_dice[6].png": "27f1",
	"./default/8_dice/8_dice[7].png": "1683",
	"./default/8_dice/8_dice[8].png": "3979",
	"./frost/100_dice/100_dice[10].png": "de86",
	"./frost/100_dice/100_dice[1].png": "e90d",
	"./frost/100_dice/100_dice[2].png": "ebba",
	"./frost/100_dice/100_dice[3].png": "3d5c",
	"./frost/100_dice/100_dice[4].png": "0c3f",
	"./frost/100_dice/100_dice[5].png": "2e0f",
	"./frost/100_dice/100_dice[6].png": "ea5c",
	"./frost/100_dice/100_dice[7].png": "7e49",
	"./frost/100_dice/100_dice[8].png": "6c3b",
	"./frost/100_dice/100_dice[9].png": "b059",
	"./frost/10_dice/10_dice[10].png": "91c6",
	"./frost/10_dice/10_dice[1].png": "e6a0",
	"./frost/10_dice/10_dice[2].png": "c2bf",
	"./frost/10_dice/10_dice[3].png": "b992",
	"./frost/10_dice/10_dice[4].png": "6820",
	"./frost/10_dice/10_dice[5].png": "0645",
	"./frost/10_dice/10_dice[6].png": "d4f5",
	"./frost/10_dice/10_dice[7].png": "2a1c",
	"./frost/10_dice/10_dice[8].png": "9b1a",
	"./frost/10_dice/10_dice[9].png": "40e7",
	"./frost/12_dice/12_dice[10].png": "bba7",
	"./frost/12_dice/12_dice[11].png": "63bb",
	"./frost/12_dice/12_dice[12].png": "a9e3",
	"./frost/12_dice/12_dice[1].png": "08ab",
	"./frost/12_dice/12_dice[2].png": "68e8",
	"./frost/12_dice/12_dice[3].png": "5437",
	"./frost/12_dice/12_dice[4].png": "c6c3",
	"./frost/12_dice/12_dice[5].png": "16df",
	"./frost/12_dice/12_dice[6].png": "045f",
	"./frost/12_dice/12_dice[7].png": "d9f8",
	"./frost/12_dice/12_dice[8].png": "2738",
	"./frost/12_dice/12_dice[9].png": "1932",
	"./frost/20_dice/20_dice[10].png": "44dc",
	"./frost/20_dice/20_dice[11].png": "c42c",
	"./frost/20_dice/20_dice[12].png": "fd42",
	"./frost/20_dice/20_dice[13].png": "b0a6",
	"./frost/20_dice/20_dice[14].png": "2c5f",
	"./frost/20_dice/20_dice[15].png": "63f1",
	"./frost/20_dice/20_dice[16].png": "bcae",
	"./frost/20_dice/20_dice[17].png": "e5c2",
	"./frost/20_dice/20_dice[18].png": "2b85",
	"./frost/20_dice/20_dice[19].png": "b05f",
	"./frost/20_dice/20_dice[1].png": "7f8b",
	"./frost/20_dice/20_dice[20].png": "8e54",
	"./frost/20_dice/20_dice[2].png": "8401",
	"./frost/20_dice/20_dice[3].png": "0984",
	"./frost/20_dice/20_dice[4].png": "58bc",
	"./frost/20_dice/20_dice[5].png": "e583",
	"./frost/20_dice/20_dice[6].png": "be56",
	"./frost/20_dice/20_dice[7].png": "a54e",
	"./frost/20_dice/20_dice[8].png": "bb7e",
	"./frost/20_dice/20_dice[9].png": "3029",
	"./frost/4_dice/4_dice[1].png": "15da",
	"./frost/4_dice/4_dice[2].png": "a586",
	"./frost/4_dice/4_dice[3].png": "b125",
	"./frost/4_dice/4_dice[4].png": "d693",
	"./frost/6_dice/6_dice[1].png": "3269",
	"./frost/6_dice/6_dice[2].png": "0b3e",
	"./frost/6_dice/6_dice[3].png": "522a",
	"./frost/6_dice/6_dice[4].png": "05a6",
	"./frost/6_dice/6_dice[5].png": "8cb1",
	"./frost/6_dice/6_dice[6].png": "4a64",
	"./frost/8_dice/8_dice[1].png": "836f",
	"./frost/8_dice/8_dice[2].png": "06e00",
	"./frost/8_dice/8_dice[3].png": "3500",
	"./frost/8_dice/8_dice[4].png": "22ac",
	"./frost/8_dice/8_dice[5].png": "3086",
	"./frost/8_dice/8_dice[6].png": "e624",
	"./frost/8_dice/8_dice[7].png": "fa23",
	"./frost/8_dice/8_dice[8].png": "71ea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "02a1";